import React from 'react';
import cn from 'classnames';

import { getPlanSubtitle } from '../../ActivationSelectSub/ActivationCustomersPlansList/utils';
import { getPlanAmountFromName } from '../../../../utils/plans';
import { findProduct, getVariantsToShow } from './utils';

import styles from './styles.module.scss';

const ActivationPlansList = ({
  sub,
  products,
  productVariant,
  setProductVariant,
}) => {
  const product = findProduct(products, sub);

  if (!product) {
    return null;
  }

  const variants = getVariantsToShow(product);

  return (
    <div className={styles.wrapper}>
      <p className={cn('text', styles.title)}>Choose a plan:</p>
      <ul className={styles.list}>
        {variants.map((variant) => {
          const { external_variant_id, title, prices } = variant;
          const price = prices[0].unit_price;
          const dataAmount = getPlanAmountFromName(title);
          return (
            <li
              className={cn({
                [styles.item]: true,
                [styles.selected]:
                  external_variant_id === productVariant?.external_variant_id,
              })}
              onClick={() => setProductVariant(variant)}
              key={external_variant_id}
            >
              <div className={cn('text-s', styles.planSubtitle)}>
                {getPlanSubtitle(dataAmount)}
              </div>
              <div className={styles.amountWrapper}>
                <span className={cn('h3', styles.amount)}>{dataAmount}</span>
                &nbsp;
                <span className={cn('text', styles.gb)}>GB</span>
              </div>
              <div className={styles.priceWrapper}>
                <span className={cn('text', styles.price)}>
                  ${Number(price)}
                </span>
                &nbsp;
                <span className={cn('text-s', styles.month)}>/month</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ActivationPlansList;
